/********************************************************************
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  Adobe permits you to use, modify, and distribute this 
 * file in accordance with the terms of the Adobe license agreement 
 * accompanying it. 
 *******************************************************************/

import { FunctionComponent, VNode } from 'preact';
import { classes } from '@adobe-commerce/elsie/lib';
import { HTMLAttributes } from 'preact/compat';
import '@adobe-commerce/elsie/components/Tag/Tag.css';

export interface TagProps
  extends Omit<HTMLAttributes<HTMLDivElement>, 'onChange' | 'icon'> {
  label?: string;
  children?: VNode | VNode[];
}

export const Tag: FunctionComponent<TagProps> = ({
  label,
  className,
  children,
  ...props
}) => {
  if (!label && !children) return null;

  return (
    <div
      {...props}
      className={classes(['dropin-tag-container', className])}
      data-testid="dropin-tag-container"
    >
      {children ?? <span className="dropin-tag-container__label">{label}</span>}
    </div>
  );
};
